import React from 'react';
import * as IMAGES from '../Images';

import './ZeroErrorState.css';

class ZeroErrorState extends React.Component {
 constructor(props) {
  super(props);
  this.state = {};
 }

 render = () => {
  return (
   <div className="zero-container">
    <img src={IMAGES.PAGE_MISS} alt="Zero State" style={{ width: '250px' }} />
    <div className="zero-content">{this.props.message}</div>
   </div>
  );
 };
}

export default ZeroErrorState;
